module.exports = __webpack_public_path__ + "img/r2.cd2d938b.svg";